<div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
  <div id="kt_app_sidebar" class="app-sidebar flex-column" data-kt-drawer="true" data-kt-drawer-name="app-sidebar"
    data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px"
    data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle" style="overflow-y: scroll;">
    <div class="app-sidebar-logo px-6" id="kt_app_sidebar_logo">
      <a href="/accueil">
        <img alt="Logo" src="/assets/media/logos/wegestu.png" class="h-90px app-sidebar-logo-default" />
        <img alt="Logo" src="/assets/media/icons/icon-wegestu.png" class="h-40px app-sidebar-logo-minimize" />
      </a>
    </div>
    <div class="app-sidebar-menu">
      <div id="kt_app_sidebar_menu_wrapper" class="">
        <div class=" my-5" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto"
          data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
          data-kt-scroll-wrappers="#kt_app_sidebar_menu" data-kt-scroll-offset="5px" data-kt-scroll-save-state="true">
          <div class="logo">
            <a href="/" class="mb-5 d-lg-none">
              <img alt="Logo" src="/assets/media/icons/icon-wegestu.png" class="h-90px app-sidebar-logo-default" />
              <img alt="Logo" src="/assets/media/logos/fav-white.png" class="h-20px app-sidebar-logo-minimize" />
            </a>
          </div>

          <div class="d-column info-user mt-5 d-lg-none">
            <div class="name mt-5"></div>
            <div class="role"></div>
          </div>
          <div class="menu menu-rounded menu-column menu-state-bg fw-semibold w-250px" data-kt-menu="true">
            <ng-container *ngFor="let item of menuItems">
              <li [routerLink]="!item.children?.length ? item.route : null" 
                routerLinkActive="active" 
                (click)="item.children?.length>0 ? toggleMenuESN(getMenuClassName(item)) : selectLink(item.route)"
                [class.active]=" (!item.children?.length && selectedLink === item.route)"
                  *ngIf="!item.children?.length && ((item.condition && item.condition(hasSubscription) || !item.condition))"
                  [ngClass]="getClass(item)"
                >
                <!-- <span  [ngClass] ="{'hide':item.title==='Nos intervenants'&& roleUser[0] !== 'ESNAB'}" >testttttt</span> -->
                <div class="item-menu"  *ngIf="item.route && !item.url">
                   <img [src]="item.icon" [alt]="item.title" width="20" height="20" class="icon-item">
                   <img [src]="item.iconHover" [alt]="item.title" width="20" height="20" class="icon-disabled">
                   <span class="menu-title" >{{ item.title }}</span>
                  <!-- <ng-container *ngIf="item.dynamicTitle; else staticTitle">
                     <span class="menu-title" >{{ item.dynamicTitle(connectedName) }}</span>
                      </ng-container> 
                      <ng-template >
                  </ng-template>-->
                </div>
                <svg  xmlns="http://www.w3.org/2000/svg" *ngIf="item.children?.length>0" [class.rotate]="openedMenus.has(getMenuClassName(item))" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
              </li>

              <li [routerLink]="!item.children?.length ? item.route : null" 
              routerLinkActive="active" 
              (click)="item.children?.length>0 ? toggleMenuESN(getMenuClassName(item)) : selectLink(item.route)"
              [class.active]="openedMenus.has(getMenuClassName(item))"
                *ngIf="item.children?.length"
                [ngClass]="{'has-item-children': item.children?.length>0, 'disabled-link': isLinkDisabled(item) }"
              >
              
                <div class="item-menu">
                  <img [src]="item.icon" [alt]="item.title" width="20" height="20" class="icon-item">
                   <img [src]="item.iconHover" [alt]="item.title" width="20" height="20" class="icon-disabled">
                  <span class="menu-title">{{ item.title }}</span>
                  <!-- <ng-container *ngIf="item.dynamicTitle; else staticTitle">
                      <span class="menu-title">{{ item.dynamicTitle(connectedName) }}</span>
                      </ng-container>
                      <ng-template >
                      <span class="menu-title">{{ item.title }}</span>
                  </ng-template> -->
                </div>
              
                <svg  xmlns="http://www.w3.org/2000/svg" *ngIf="item.children?.length>0" [class.rotate]="openedMenus.has(getMenuClassName(item))" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
              </li>
              <ul *ngIf="item.children?.length > 0 && openedMenus.has(getMenuClassName(item))">
                <li *ngFor="let child of item.children"
                    [routerLink]="child.route" 
                    routerLinkActive="active" 
                    (click)="selectLink(child.route)"
                    [class.active]="selectedLink === child.route"
                    [ngClass]="{'disabled-link': isLinkDisabled(child)}"
                >
                  {{ child.title }}
                </li>
              </ul>

              <!-- If item has a route and no children, render it as a link with 'hover show' class -->
              <!-- <li [routerLink]="!item.children?.length ? item.route : null" 
                routerLinkActive="active" 
                (click)="item.children?.length>0 ? toggleMenuESN(getMenuClassName(item)) : selectLink(item.route)"
                [class.active]="openedMenus.has(getMenuClassName(item)) || (!item.children?.length && selectedLink === item.route)"
                *ngIf="item.title &&   ((item.condition && item.condition(hasSubscription) || !item.condition))"
                [ngClass]="{'has-item-children': item.children?.length>0, 'disabled-link': isLinkDisabled(item) }"
              > -->
               <!-- <div class="menu-item"
                *ngIf="!item.children && ((item.condition && item.condition(hasSubscription) || !item.condition))">
                <a *ngIf="item.route && !item.url" [routerLink]="item.route" class="menu-link py-3"
                  routerLinkActive="active" [ngClass]="{'disabled-link': isLinkDisabled(item)}">
                  <span class="menu-icon">
                    <img [src]="item.icon" [alt]="item.title" width="20" height="20">
                  </span>
                  <ng-container *ngIf="item.dynamicTitle; else staticTitle">
                    <span class="menu-title">{{ item.dynamicTitle(connectedName) }}</span>
                  </ng-container>
                  <ng-template #staticTitle>
                    <span class="menu-title">{{ item.title }}</span>
                  </ng-template>
                </a>

                <a *ngIf="item.onclick && !item.route && !item.url" (click)="item.onclick()" class="menu-link py-3"
                  [ngClass]="{'disabled-link': isLinkDisabled(item)}">
                  <span class="menu-icon">
                    <img [src]="item.icon" [alt]="item.title" width="20" height="20">
                  </span>
                  <span class="menu-title">{{ item.title }}</span>
                </a>
              </div> -->

              <!-- If item has children, render it as a collapsible menu without 'hover show' class -->
              <!-- <div class="menu-item menu-link-indention menu-accordion" *ngIf="item.children"
                data-kt-menu-trigger="click">
                <a class="menu-link py-3" (click)="toggleMenu(item)" routerLinkActive="active"
                [ngClass]="{'disabled-link': isLinkDisabled(item)}">
                  <span class="menu-icon">
                    <img [src]="item.icon" [alt]="item.title" width="20" height="20">
                  </span>
                  <span class="menu-title">{{ item.title }} </span>
                  <span class="menu-arrow"></span>
                </a>
                <div class="menu-sub menu-sub-accordion pt-3" *ngIf="isMenuOpen(item)">
                  <div class="menu-item" *ngFor="let child of item.children">
                    <a *ngIf="child.route && !child.url" [routerLink]="child.route" class="menu-link py-3"
                      routerLinkActive="active" [ngClass]="{'disabled-link': isLinkDisabled(child)}">
                      <span class="menu-title">{{ child.title }}</span>
                    </a>
                    <a *ngIf="!child.route && child.url" [href]="child.url" target="_blank" rel="noopener noreferrer"
                      class="menu-link py-3">
                      <span class="menu-title">{{ child.title }}</span>
                    </a>
                  </div>
                </div>
              </div> -->


            </ng-container>
          </div>

        </div>
        <!--end::Scroll wrapper-->
      </div>
    </div>
  </div>
</div>
